import ConfirmedDialogTemplate from '@/components/dialogs/ConfirmedDialogTemplate.vue';
import DialogTemplate from '@/components/dialogs/DialogTemplate.vue';
import store from '@/store';
import { Vue } from 'vue-property-decorator';
import { errorMessages } from '../globals/errorMessages';
import httpErrorActions from '../globals/httpErrorActions';
import { generateHttpDialogMessage } from '@/globals/httpErrorMessage';
import { generateCognitoDialogMessage } from '@/globals/cognitoErrorMessge';
import { applyAuthRouteDialogClass } from '@/utils/dialog.helper';

export default class DialogService {
  arrDialog = [];
  defaultOptions = {
    clickToClose: false,
    minHeight: 400,
    width: 800,
    height: 'auto',
  };

  defaultDatas = {
    title: '',
    text: '',
    btnCloseOutside: true,
    isConfirmedDialogClose: false,
  };

  defaultDatasConfirm = {
    title: '',
    content: '',
    cancel: true,
    ok: true,
    close: false,
    textCancel: 'キャンセル',
    textOK: 'O K',
    loading: false,
  };

  show(nameComponent, data = {}, config = {}, event = null) {
    const index = this.arrDialog.findIndex(
      (item) => item === nameComponent.name
    );
    if (index > -1) {
      return null;
    }
    this.arrDialog.push(nameComponent.name);
    // this.dialogStore.changeNameDialog(arrDialog)
    store.dispatch('dialog/changeNameDialog', this.arrDialog);

    data.namecomponent = nameComponent;
    data.eventReturnData = event;
    const options = {
      ...{ ...this.defaultOptions },
      ...config,
      name: nameComponent.name,
    };
    const dataModals = { ...this.defaultDatas, ...data };
    if (dataModals.full) {
      document.getElementsByTagName('html')[0].classList.add('hasModal');
    }
    Vue.prototype.$modal.show(
      DialogTemplate,
      {
        dataDialog: dataModals,
      },
      options,
      {
        'before-close': () => this.close(nameComponent.name),
      }
    );
  }

  showConfirmDialog(data = {}, config = {}, event = null) {
    const index = this.arrDialog.findIndex(
      (item) => item === 'ConfirmedDialogTemplate'
    );
    if (index > -1) {
      return null;
    }
    this.arrDialog.push('ConfirmedDialogTemplate');
    // this.dialogStore.changeNameDialog(this.arrDialog)
    store.dispatch('dialog/changeNameDialog', this.arrDialog);

    data.eventReturnData = event;
    config.width = config.width || 400;
    const options = {
      ...this.defaultOptions,
      ...config,
    };
    if (config.height) {
      options.minHeight = config.height;
    }
    const dataModals = { ...this.defaultDatasConfirm, ...data };
    options.name = 'ConfirmedDialogTemplate';
    Vue.prototype.$modal.show(
      ConfirmedDialogTemplate,
      {
        dataDialog: dataModals,
      },
      options,
      {
        'before-close': () => this.close('ConfirmedDialogTemplate'),
      }
    );
  }

  showErrorDialog(data = {}, config = {}, event = null) {
    const index = this.arrDialog.findIndex(
      (item) => item === 'ErrorDialogTemplate'
    );

    if (index > -1) {
      return null;
    }
    this.arrDialog.push('ErrorDialogTemplate');
    store.dispatch('dialog/changeNameDialog', this.arrDialog);
    data.eventReturnData = event;
    config.width = config.width || 400;
    const options = {
      ...this.defaultOptions,
      ...config,
      adaptive: true,
    };
    const dataModals = { ...this.defaultDatasConfirm, ...data };
    options.name = 'ErrorDialogTemplate';
    Vue.prototype.$modal.show(
      ConfirmedDialogTemplate,
      {
        dataDialog: dataModals,
      },
      options,
      {
        'before-close': () => {
          this.close('ErrorDialogTemplate');
        },
      }
    );
  }

  httpError({ status, error, request, response }) {
    const dialogErrorData =
      generateHttpDialogMessage({ status, error, request, response }) ||
      errorMessages.httpStatus.common;

    let dialogAction = httpErrorActions[status] || httpErrorActions.common;
    // handle error code 99003 - force logout
    if (status === 500 && error?.errorCode === 99003) {
      dialogAction = httpErrorActions[401];
    }

    const config = {
      width: dialogErrorData.width || 560,
    };

    applyAuthRouteDialogClass(config);

    this.showErrorDialog(
      {
        title: dialogErrorData.title,
        content: dialogErrorData.body,
        cancel: false,
        hideCloseIcon: dialogErrorData.hideCloseIcon,
        code: dialogErrorData.code,
      },
      config,
      () => {
        this.closeAll();
        dialogAction();
      }
    );
  }

  cognitoError({ error }) {
    const dialogErrorData = generateCognitoDialogMessage({ error });
    const dialogAction =
      httpErrorActions[dialogErrorData.status] || httpErrorActions.common;
    const config = {
      width: dialogErrorData.width || 560,
    };

    if (dialogErrorData.classes) {
      config.classes = dialogErrorData.classes;
    }

    applyAuthRouteDialogClass(config);

    this.showErrorDialog(
      {
        title: dialogErrorData.title,
        content: dialogErrorData.body,
        cancel: false,
        hideCloseIcon: dialogErrorData.hideCloseIcon,
        code: dialogErrorData.code,
      },
      config,
      () => {
        this.closeAll();
        dialogAction();
      }
    );
  }

  close(nameComponent) {
    const index = this.arrDialog.findIndex((item) => item === nameComponent);
    document.getElementsByTagName('html')[0].classList.remove('hasModal');
    if (index > -1) {
      this.arrDialog.splice(index, 1);
      setTimeout(() => {
        store.dispatch('dialog/changeNameDialog', this.arrDialog);
      }, 200);
    }
  }

  closeAll() {
    setTimeout(() => {
      for (const component of this.arrDialog) {
        Vue.prototype.$modal.hide(component);
        store.dispatch('dialog/changeNameDialog', []);
      }
    }, 300);
  }

  addSnack(snack) {
    store.dispatch('dialog/addSnack', snack);
  }
}

export const dialogService = new DialogService();
